export function isUUID(s: string) {
  return /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(
    s
  )
}

export const isEqualLowerCase = (a: string, b: string) =>
  a?.toLowerCase() === b?.toLocaleLowerCase()
